import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import AlignBg from "../AlignBg";
import { ProjectCard } from "./Sections/ProjectSection";
import ProjectModal from "../ProjectModal";
import SectionHeading from "../SectionHeading";
import { SYSTEMS_PROJECTS, SOFTWARE_PROJECTS } from "../data/projects";
import { stagger } from "../motion";
import "../css/Projects.css";

function Projects() {
  const [activeProject, setActiveProject] = useState(null);

  return (
    <div>
      <AlignBg name="Projects" title="Projects" />

      <section className="section">
        <div className="container">
          <SectionHeading
            eyebrow="Systems Engineering"
            title="Infrastructure & IT projects"
            subtitle="Enterprise deployments and migrations — click any card to read the full case study."
          />
          <motion.div
            className="project-grid"
            variants={stagger}
            initial="hidden"
            animate="visible"
          >
            {SYSTEMS_PROJECTS.map((project) => (
              <ProjectCard
                key={project.title}
                project={project}
                onOpenCase={setActiveProject}
              />
            ))}
          </motion.div>
        </div>
      </section>

      <section className="section" style={{ paddingTop: 0 }}>
        <div className="container">
          <SectionHeading
            eyebrow="Software Development"
            title="Apps & websites"
            subtitle="Front-end and full-stack builds — click through to the live projects."
          />
          <motion.div
            className="project-grid"
            variants={stagger}
            initial="hidden"
            animate="visible"
          >
            {SOFTWARE_PROJECTS.map((project) => (
              <ProjectCard key={project.title} project={project} />
            ))}
          </motion.div>
        </div>
      </section>

      <AnimatePresence>
        {activeProject && (
          <ProjectModal
            project={activeProject}
            onClose={() => setActiveProject(null)}
          />
        )}
      </AnimatePresence>
    </div>
  );
}

export default Projects;
